import Link from "@insightfulscience/atomic-react/Link";
import Block from "@insightfulscience/atomic-react/Block";
import Heading from "@insightfulscience/atomic-react/Heading";
import Image from "@insightfulscience/atomic-react/Image";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import { bool, string } from "prop-types";
import { colorPropTypes } from "@insightfulscience/atomic-react/props/sx";
import React from "react";

const ProductsTab = ({ borderColor, logoIcon, title, description, active, ...props }) => {
	const { href } = props;
	const border = { top: { color: active ? borderColor : "white", width: "4" } };
	const CustomLink = ({ ...customProps }) => <Link {...customProps} isBaseClassName={false} />;
	const Tag = href ? CustomLink : Block;

	return (
		<Tag {...props} sx={{ fontColor: "black" }}>
			<Block
				sx={{ textAlign: "center" }}
				utility={{
					bgColor: active ? "dotmatics-4" : "white",
					border,
				}}
				spacing={{ pt: 4, pb: 5 }}
				{...props}
			>
				<Heading Tag="h3" size="l" center>
					{title} {logoIcon && <Image src={logoIcon} spacing={{ ml: 1 }} />}
				</Heading>
				{description && <Paragraph spacing={{ mb: 0 }}>{description}</Paragraph>}
			</Block>
		</Tag>
	);
};

ProductsTab.propTypes = {
	active: bool,
	borderColor: colorPropTypes,
	logoIcon: string,
	title: string,
	description: string,
	href: string,
};

export default ProductsTab;
